import { GeocodeAddress } from './address-form.types';

const addressMap = {
  streetAddress1: ['street_number'],
  streetAddress11: ['street_address', 'route'],
  city: [
    'locality',
    'sublocality',
    'sublocality_level_1',
    'sublocality_level_2',
    'sublocality_level_3',
    'sublocality_level_4',
  ],
  region: [
    'administrative_area_level_1',
    'administrative_area_level_2',
    'administrative_area_level_3',
    'administrative_area_level_4',
    'administrative_area_level_5',
  ],
  country: ['country'],
  postalCode: ['postal_code'],
};

export const geocodeToAddress = (geocode, addressValueMap) => {
  const address: GeocodeAddress = {
    streetAddress1: '',
    streetAddress11: '',
    city: {
      locality: '',
      sublocality: '',
      sublocality_level_1: '',
      sublocality_level_2: '',
      sublocality_level_3: '',
      sublocality_level_4: '',
    },
    region: {
      administrative_area_level_1: '',
      administrative_area_level_2: '',
      administrative_area_level_3: '',
      administrative_area_level_4: '',
      administrative_area_level_5: '',
    },
    country: '',
    postalCode: '',
  };

  geocode.address_components.forEach(component => {
    Object.entries(addressMap).forEach(([key, value]) => {
      if (component.types.some(componentType => value.includes(componentType)))
        address[key] = component[addressValueMap[key]];
    });
  });

  address.streetAddress1 = `${address.streetAddress1} ${address.streetAddress11}`;
  delete address.streetAddress11;

  return address;
};
